import navigation from "@/lang/it/navigation";
import generics from "@/lang/it/generics";
import questions from "@/lang/it/questions";
import a11y from "@/lang/it/a11y";
import velt from "@/lang/it/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
